import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { env } from "../../env";
var domain;
if (env.REACT_APP_ENV === "development") {
    domain = "http://localhost:3000";
} else if (env.REACT_APP_ENV === "uat") {
    domain = env.REACT_APP_DOMAIN_UAT;
} else {
    domain = env.REACT_APP_DOMAIN_PROD;
}
export { domain };
export var apiUrl = "/api/v1";
export var COMPANY_LOGO = env.REACT_APP_COMPANY_LOGO_URL;
export var HWC_MAIN_URL = env.REACT_APP_HWC_MAIN_URL;
export var YES = "YES";
export var NO = "NO";
export var OK = "OK";
export var TOKEN = "TOKEN";
export var VER = "1.7.10";
var authEndPoint = {
    LOGIN_URL: "".concat(apiUrl, "/auth/login"),
    VERIFY_ROLE_LOG: "".concat(apiUrl, "/verify-role-log"),
    NEW_ALLDERNOW_USER: "".concat(apiUrl, "/new-alldernow-user"),
    USER_INFO: "".concat(apiUrl, "/new-alldernow-user/get-user-info")
};
var masterEndPoint = {
    MST_PREFIX_URL: "".concat(apiUrl, "/mst-prefix"),
    MST_SEX_URL: "".concat(apiUrl, "/mst-sex"),
    MST_MARITAL_STATUS: "".concat(apiUrl, "/mst-marital-status"),
    MST_MILITARY_STATUS: "".concat(apiUrl, "/mst-military-status"),
    MST_RELATIONSHIP: "".concat(apiUrl, "/mst-relationship"),
    MST_EMPLOYEE_TYPE: "".concat(apiUrl, "/mst-employee-type"),
    MST_DEPARTMENT: "".concat(apiUrl, "/mst-department"),
    MST_POSITION: "".concat(apiUrl, "/mst-position"),
    MST_BANK: "".concat(apiUrl, "/mst-bank"),
    MST_BANK_ACCOUNT_TYPE: "".concat(apiUrl, "/mst-bank-account-type"),
    MST_EMPLOYEE_DOC: "".concat(apiUrl, "/mst-employee-doc"),
    MST_BRANCH: "".concat(apiUrl, "/mst-branch"),
    MST_BUSINESS_TYPE: "".concat(apiUrl, "/mst-business-type"),
    MST_BUSINESS_CATEGORY: "".concat(apiUrl, "/mst-business-category"),
    MST_COMPANY_PREFIX: "".concat(apiUrl, "/mst-company-prefix"),
    MST_PAYMENT_METHOD: "".concat(apiUrl, "/mst-payment-method"),
    MST_PAYMENT_TERM: "".concat(apiUrl, "/mst-payment-term"),
    MST_SUPPLIER_DOC: "".concat(apiUrl, "/mst-supplier-doc"),
    MST_NEW_ALLDERNOW_ROLE: "".concat(apiUrl, "/mst-new-alldernow-role"),
    MST_PAYMENT_TYPE: "".concat(apiUrl, "/mst-payment-type"),
    MST_DISCOUNT_TYPE: "".concat(apiUrl, "/mst-discount-type"),
    MST_PRICE_CATEGORY: "".concat(apiUrl, "/mst-price-category"),
    MST_VAT: "".concat(apiUrl, "/mst-vat"),
    WAREHOUSE: "".concat(apiUrl, "/warehouse"),
    MASTER_BRAND: "".concat(apiUrl, "/master-brand"),
    MASTER_MAIN_CATEGORY: "".concat(apiUrl, "/master-main-category"),
    MST_NEW_ITEM_PR_COL: "".concat(apiUrl, "/mst-new-item-pr-col"),
    MST_OFFICE_SECTION: "".concat(apiUrl, "/mst-office-section"),
    MST_COMPANY: "".concat(apiUrl, "/mst-company/find-first"),
    MST_MART: "".concat(apiUrl, "/mst-mart/find-first"),
    MST_ADD_COST: "".concat(apiUrl, "/mst-add-cost"),
    MST_ADD_COST_UNIT: "".concat(apiUrl, "/mst-add-cost-unit"),
    MST_NEW_ITEM_EXPENSE_COL: "".concat(apiUrl, "/mst-new-item-expense-col"),
    MST_WITHHOLDING_TAX: "".concat(apiUrl, "/mst-withholding-tax"),
    MST_EXPENSE_TYPE: "".concat(apiUrl, "/mst-expense-type"),
    MST_NEW_ITEM_QO_COL: "".concat(apiUrl, "/mst-item-qo-col"),
    MST_NEW_ITEM_SO_COL: "".concat(apiUrl, "/mst-item-so-col"),
    MST_NEW_ITEM_DO_COL: "".concat(apiUrl, "/mst-item-do-col"),
    MST_NEW_ITEM_INVOICE_COL: "".concat(apiUrl, "/mst-item-invoice-col"),
    MST_NEW_ITEM_RECEIPT_COL: "".concat(apiUrl, "/mst-item-receipt-col"),
    MST_NEW_ITEM_PES_COL: "".concat(apiUrl, "/mst-item-pes-col"),
    MST_PAYMENT_INV_TYPE: "".concat(apiUrl, "/mst-payment-inv-type"),
    MST_ADJUST_OR_FEE: "".concat(apiUrl, "/mst-adjust-or-fee"),
    BRANCH_PAYMENT_CHANNEL: "".concat(apiUrl, "/branch-payment-channel")
};
var logicEndPoint = {
    NEW_ALLDERNOW_EMP: "".concat(apiUrl, "/new-alldernow-emp"),
    GROUP_OF_SUPPLIER: "".concat(apiUrl, "/group-of-supplier"),
    SUPPLIER_INFORMATION: "".concat(apiUrl, "/supplier-information"),
    PRODUCT_PRICE: "".concat(apiUrl, "/product-price"),
    NEW_PURCHASE_REQ: "".concat(apiUrl, "/new-purchase-req"),
    NEW_PURCHASE_ORDER: "".concat(apiUrl, "/new-purchase-order"),
    NEW_PO_SPLIT: "".concat(apiUrl, "/new-po-split"),
    NEW_PO_SPLIT_EXPORT: "".concat(apiUrl, "/new-po-split/export"),
    NEW_GR: "".concat(apiUrl, "/new-gr"),
    HISTORY_BRANCH_ADDRESS: "".concat(apiUrl, "/history-branch-address"),
    EXPENSE: "".concat(apiUrl, "/expense"),
    NEW_QO: "".concat(apiUrl, "/new-qo"),
    MEMBER: "".concat(apiUrl, "/member"),
    NEW_SO: "".concat(apiUrl, "/new-so"),
    NEW_DO: "".concat(apiUrl, "/new-do"),
    NEW_INVOICE: "".concat(apiUrl, "/new-invoice"),
    NEW_RECEIPT: "".concat(apiUrl, "/new-receipt"),
    PES: "".concat(apiUrl, "/pes")
};
var reportEndPoint = {
    REPORT_PURCHASE_PRODUCT_PO_ITEM: "".concat(apiUrl, "/report-purchase-product-po-item"),
    REPORT_PURCHASE_SUPPLIER: "".concat(apiUrl, "/report-purchase-supplier"),
    REPORT_PURCHASE_ORDER: "".concat(apiUrl, "/report-purchase-order"),
    REPORT_RECEIVE_PRODUCT_GR_ITEM: "".concat(apiUrl, "/report-receive-product-gr-item"),
    REPORT_PRODUCT_DO: "".concat(apiUrl, "/report-product-do")
};
export var endPoint = _object_spread({}, authEndPoint, masterEndPoint, logicEndPoint, reportEndPoint);
